import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const FinanceDashboard = lazy(() => import("@/pages/agent/financial/dashboard/FinanceDashboard"));
const UnclaimedCommissions = lazy(
  () => import("@/pages/agent/financial/unclaimed-commissions/UnclaimedCommissions/UnclaimedCommissions"),
);
const DirectDeposits = lazy(() => import("@/pages/agent/financial/direct-deposits/DirectDeposits/DirectDeposits"));

const Error404 = lazy(() => import("@/pages/Error404"));

const financialRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "dashboard",
    element: <FinanceDashboard />,
  },
  {
    path: "unclaimed-commissions",
    element: <UnclaimedCommissions />,
  },
  {
    path: "direct-deposits",
    element: <DirectDeposits />,
  },
];

export default financialRoutes;
